import React from "react";

const PageHeader = ({ title, description, actions }) => (
  <header className="wcco-page-header">
    <div>
      <h1 className="wcco-page-header__title">{title}</h1>
      {description && <p className="wcco-page-header__description">{description}</p>}
    </div>
    {actions && <div className="wcco-page-header__actions">{actions}</div>}
  </header>
);

export default PageHeader;
